import {store} from "./../../store/store";
import { logout } from "../pages/auth/authAction";
import { ApiClient } from "./client";
import { LS_TOKEN_KEY, BASE_URL } from "./models/constants";

export const api = ApiClient.create(BASE_URL);

export const createApiCall = async ({ method, params }) => {
  return api[method](params);
};

if (typeof window !== "undefined") {
  const token = window.localStorage.getItem(LS_TOKEN_KEY);

  if (token) {
    api.setJwtToken(token);
  }
}

api.addErrorInterceptor((error) => {
  if (error.response && error.response.status === 401) {
    store.dispatch(logout());
  }

  return Promise.reject(error);
});
